import angular from 'angular';

(function () {
    'use strict';

    angular.module('app.core').factory('DoSvc', DoSvc);

    DoSvc.$inject = ['$state', 'CompanyFilter', 'ContainersFilter', 'PrincipalSvc'];

    function DoSvc($state, CompanyFilter, ContainersFilter, PrincipalSvc) {
        var tabs = {
            principal: false,
            company: false,
            container: false,
        };

        var exports = {
            updateTabStatus: updateTabStatus,
            goToCompany: goToCompany,
            goToContainer: goToContainer,
            selectTab: selectTab,
        };

        return exports;

        // Change l'onglet actif
        function selectTab(tabName) {
            $state.go('do', { tabName: tabName }, { notify: false });
            this.activeTabName = tabName;
            this.updateTabStatus();
        }

        function goToCompany(row) {
            var companyFilter = new CompanyFilter();
            companyFilter.setPrincipalEid(row.entity.principalEid);
            PrincipalSvc.setCompanyListFilter(companyFilter);
            this.selectTab('company');
        }

        function goToContainer(row) {
            var containersFilter = new ContainersFilter();
            containersFilter.setPrincipalEid(row.entity.principalEid);
            containersFilter.setCompanyId(row.entity.companyId);
            PrincipalSvc.setContainerListFilter(containersFilter);
            this.selectTab('container');
        }

        function updateTabStatus() {
            tabs.principal = false;
            tabs.company = false;
            tabs.container = false;
            switch (this.activeTabName) {
                case 'principal':
                    tabs.principal = true;
                    this.activeTabIndex = 0;
                    break;
                case 'company':
                    tabs.company = true;
                    this.activeTabIndex = 1;
                    break;
                case 'container':
                    tabs.container = true;
                    this.activeTabIndex = 2;
                    break;
                default:
                    break;
            }
        }
    }
})();
